import config from '@/config';
import axios from 'axios';

export default axios.create({
  baseURL: `${config.API_URL}`,
  withCredentials: true,
  headers: {
    'Request-Origin': 'vue'
  }
});
